import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "brand-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar-logo-container m-rail", [_ctx.collapse ? 'collapse' : 'notitle']])
  }, [
    _createVNode(_component_router_link, {
      class: "sidebar-logo-link",
      to: "/"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _ctx.Logo,
          class: "sidebar-logo-img",
          alt: "Logo"
        }, null, 8, _hoisted_1),
        (!_ctx.collapse)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "brand-name" }, "管理后台", -1),
              _createElementVNode("span", { class: "brand-sub" }, "ENTERPRISE ERP", -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}